<template>
    <div>
        <div class="alert alert-dismissible fade show" :class="category" role="alert" v-show="toggle">
            <slot name="content"></slot>
            <button type="button" class="close" data-hide="alert" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
    </div>

</template>

<script>
    export default {
        props: ['category', 'toggle'],
        mounted() {
            $(function() {
                $("[data-hide]").on("click", function() {
                    $(this).closest("." + $(this).attr("data-hide")).hide();
                });
            });
        }
    }
</script>